<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div :class="['spotlight-result-icon', thumbUrl ? 'spotlight-result-icon--music-thumb' : 'spotlight-result-icon--music']">
            <img v-if="thumbUrl" :src="thumbUrl" alt=""/>
            <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">
                <span class="spotlight-result-title-text">{{ item.title }}</span>
            </div>
            <div class="spotlight-result-subtitle">{{ subtitle }}</div>
        </div>
        <div v-if="duration" class="spotlight-result-meta">
            <span class="spotlight-result-meta-muted">{{ duration }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MusicTrackResult',
    props: { item: Object, focused: Boolean },
    emits: ['select'],
    computed: {
        thumbUrl() {
            return this.item.meta?.thumb || null
        },
        duration() {
            const d = this.item.meta?.duration
            if (d == null) return '--:--'
            const sec = Math.round(d)
            const min = Math.floor(sec / 60)
            const s = sec % 60
            return min + ':' + String(s).padStart(2, '0')
        },
        subtitle() {
            const parts = []
            if (this.item.meta?.size_text) parts.push(this.item.meta.size_text)
            if (this.item.subtitle) parts.push(this.item.subtitle.toUpperCase())
            return parts.join(' · ') || null
        },
    },
}
</script>
